export class EntraIdEntitySelection {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "mode",
            "baseName": "mode",
            "type": "EntraIdSelectionMode",
            "format": ""
        },
        {
            "name": "includeIds",
            "baseName": "includeIds",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "excludeIds",
            "baseName": "excludeIds",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return EntraIdEntitySelection.attributeTypeMap;
    }
    constructor() {
    }
}
